import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom'
import App from './App'
import BlankSilhouette from './components/custom-canvas/BlankSilhouette'
import WordSilhouette from './components/apps/word/WordSilhouette'
import FormsSilhouette from './components/apps/forms/FormsSilhouette'
import './index.css'

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <Router>
      <Routes>
        <Route path="/" element={<Navigate to="/home" replace />} />
        <Route path="/home" element={<App />} />
        <Route path="/forms" element={<FormsSilhouette />} />
        <Route path="/blank-silhouette" element={<BlankSilhouette />} />
        <Route path="/word-silhouette" element={<WordSilhouette />} />
        <Route path="/forms-silhouette" element={<FormsSilhouette />} />
      </Routes>
    </Router>
  </React.StrictMode>,
)
